module.exports = __webpack_public_path__ + "img/spartan-build-design-01-xxlarge.db016ad1.jpg";